export default {
  headerState: {}
};
